import { Component, OnChanges, QueryList, SimpleChanges, ViewChildren, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CourseService } from '../../../../services/course.service';
import { CourseCall, CourseChat, Questions, Lesson } from '../../../../models/CourseCall';
import { DatePipe, NgClass, NgForOf, NgIf } from '@angular/common';
import { GenericFormComponent } from '../../../../shared/components/generic-crud/generic-form/generic-form.component';
import { GenericForm, GenericFormField } from '../../../../models/GenericCRUD/GenericForm';
import { Unit } from '../../../../models/VirtualClassroom';
import { SafeUrlPipe } from '../../../../shared/pipes/safe-url.pipe';
import { Media } from '../../../../models/Media';
import { BreadcrumbService } from '../../../../core/services/breadcrumb/breadcrumb.service';
import { GenericCrudComponent } from "../../../../shared/components/generic-crud/generic-crud.component";
import { GenericTable, GenericTableAction, GenericTableColumn } from '../../../../models/GenericCRUD/GenericTable';
import { Paginator } from '../../../../models/Paginator';
import { GenericCRUD } from '../../../../models/GenericCRUD/GenericCRUD';
import { FormInputDirective } from '../../../../shared/directives/form-input.directive';
import { FormsModule, NgModel, ReactiveFormsModule } from '@angular/forms';
import { AuthService } from '../../../../services/auth.service';
import { AuthStateService } from '../../../../core/states/auth-state.service';
import { GenericCrudService } from '../../../../services/generic-crud.service';
import { ToastrService } from 'ngx-toastr';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { CustomDropdownComponent } from '../../../../shared/components/form-controls/custom-dropdown/custom-dropdown.component';

@Component({
  selector: 'app-course-call-details',
  standalone: true,
  imports: [NgForOf, NgClass, NgIf, GenericFormComponent, SafeUrlPipe, GenericCrudComponent, DatePipe, FormInputDirective, ReactiveFormsModule, FormsModule, ModalComponent, CustomDropdownComponent],
  templateUrl: './course-call-details.component.html',
  styleUrl: './course-call-details.component.css'
})
export class CourseDetailsComponent implements OnChanges, AfterViewInit {
  @ViewChild('studentsCrud', { read: ElementRef }) studentsCrud!: ElementRef;
  course!: CourseCall;
  selectedLesson!: Lesson;

  userId!: number;
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['lessonIndexTab']) {
      this.selectedLesson = this.course.lessons[this.lessonIndexTab];
    }
  }

  courseFormFields: GenericFormField[] = [
    { name: 'course_id', type: 'select', label: 'Curso', validations: 'required', url: '/config/course/all', singleSelection: true },
    { name: 'start_date', type: 'date', label: 'Fecha de Inicio', validations: 'required' },
    { name: 'end_date', type: 'date', label: 'Fecha de Fin', validations: 'required' },
    { name: 'expiration_date', type: 'date', label: 'Fecha de Expiración', validations: 'required' },
    { name: 'registration_deadline', type: 'date', label: 'Tope de Inscripción', validations: 'required' },
    { name: 'capacity', type: 'number', label: 'Capacidad del Curso', validations: 'required' },
    { name: 'teachers', type: 'select', label: 'Profesores', validations: 'required', url: '/user/teachers', singleSelection: false },
    { name: 'office_id', type: 'select', label: 'Sucursal', validations: 'required', url: '/config/office/listAll', singleSelection: true },
    { name: 'classroom_id', type: 'select', label: 'Clase', singleSelection: true, fieldListener: 'office_id', subfieldListener: 'classrooms', url: '/config/office/listAll' },
    { name: 'lessons', type: 'dateRepeater', label: 'Días', fieldListener: 'teachers', colspan: 2, showIf: (formValue: any) => {
      const course = formValue?.course_id;
      if (!course) return true;
      const type = typeof course === 'object' ? course.type : null;
      return type !== 'Practico';
    }}
  ];

  unitFormFields: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre', validations: 'required' },
    { name: 'description', type: 'textarea', label: 'Descripción', colspan: 2 },
    { name: 'images', type: 'image', label: 'Imagenes', colspan: 2, singleSelection: false, url: '/config/office/uploadFiles' },
    { name: 'videos', type: 'video', label: 'Videos', colspan: 2, singleSelection: false, url: '/config/office/uploadFiles' },
    { name: 'documents', type: 'document', label: 'Documentos', colspan: 2, singleSelection: false, url: '/config/office/uploadFiles' },
  ];


  lessonUsersTableCols: GenericTableColumn[] = [
    { name: 'Alumno', active: true, type: 'text', key: 'name', sort: true },
    { name: 'Asistencia', active: true, type: 'reactive-boolean', key: 'presence', sort: false, buttonActionKey: 'change-presence', onLabel: 'Asistido', offLabel: 'No asistido' },
    { name: 'Calificación', active: true, type: 'text', key: 'qualification_name', sort: false },
    { name: 'Comentarios', active: true, type: 'custom', key: 'add-comment-button', sort: false },
    { name: 'Fecha Creación', active: false, type: 'date', key: 'created_at', sort: true, format: 'dd/MM/yyyy hh:mm:ss' },
    { name: 'Fecha Modificación', active: false, type: 'date', key: 'updated_at', sort: true, format: 'dd/MM/yyyy hh:mm:ss' },
  ];

  lessonUsersFormField: GenericFormField[] = [];

  // Configuración para chat privado
  privateChatTableColumns: GenericTableColumn[] = [
    { name: 'Profesor', active: true, type: 'text', key: 'teacher_name', sort: true },
    { name: 'Último mensaje', active: true, type: 'text', key: 'last_message', sort: false },
    { name: 'Fecha', active: true, type: 'date', key: 'last_message_date', sort: true, format: 'dd/MM/yyyy HH:mm' },
    { name: 'Estado', active: true, type: 'text', key: 'status', sort: false },
    { name: 'Acciones', active: true, type: 'text', key: 'actions', sort: false }
  ];

  privateChatTableActions: GenericTableAction[] = [
    {
      name: 'Abrir chat',
      key: 'open-chat',
      icon: 'chat',
      confirmation: false,
      actionSlug: '/chat/private/open/{{teacher_id}}',
      showIf: (item: any) => true
    },
    {
      name: 'Marcar como leído',
      key: 'mark-read',
      icon: 'check',
      confirmation: false,
      actionSlug: '/chat/private/mark-read/{{id}}',
      showIf: (item: any) => item.unread_count > 0
    }
  ];

  studentFormFields: GenericFormField[] = [];

  courseForm!: GenericForm;

  studentForm!: GenericForm;
  studentsCRUD!: GenericCRUD<any>;

  unitForm!: GenericForm;

  studentsTable!: GenericTable<any>

  studentCruds!: GenericCRUD<any>[]

  // Evaluación masiva de alumnos
  selectedStudentIds: Set<number> = new Set();
  qualifications: any[] = [];
  selectedQualificationId: number | null = null;
  assigningQualification = false;

  selectedUnit!: Unit | undefined;

  today: Date = new Date();

  activeCourseForm: boolean = false;

  activeUnitForm: boolean = false;

  activeListenerForm: boolean = false;

  activeStudentForm: boolean = false;
  allowOpenModal: boolean = false;

  lessonIndexTab = 0;

  activeTabIndex = 0;

  showBookModal = false;
  showVideoModal = false;
  showImageModal = false;
  medias: Media[] | null = null;

  showChatModal = false;
  courseChats: CourseChat[] | null = null;
  courseQuestions: Questions[] | null = null;

  // Chat privado
  showPrivateChatModal = false;
  selectedTeacher: any = null;
  privateChatMessages: any[] = [];
  newPrivateMessageText: string = '';
  currentChatId: number | null = null;

  // GenericCRUD para chat privado
  privateChatCrud!: GenericCRUD<any>;

  @ViewChildren(GenericCrudComponent) genericCruds!: QueryList<GenericCrudComponent>;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private courseService: CourseService,
    private breadcrumbService: BreadcrumbService,
    private authService: AuthStateService,
    private genericCrudService: GenericCrudService,
    private toastr: ToastrService
  ) {
    const navItem = this.router.getCurrentNavigation()?.extras?.state?.['item'];
    if (navItem) {
      const name = navItem.name || navItem.course_name || navItem.course?.name;
      if (name) {
        const courseId = this.route.snapshot.paramMap.get('id');
        this.breadcrumbService.setBreadcrumb({
          display_name: name,
          url: `/dashboard/convocatorias/${courseId}`,
          items: [
            { name: 'Convocatoria de Cursos', url: '/dashboard/convocatorias' },
            { name, url: `/dashboard/convocatorias/${courseId}` }
          ]
        });
      }
    }
    this.loadCourse();
  }

  private loadCourse() {
    let courseId = this.route.snapshot.paramMap.get('id');
    if (this.authService.currentUserValue && this.authService.currentUserValue.profile)
      this.userId = this.authService.currentUserValue.profile.id
    if (courseId) {
      this.courseService.get(+courseId).subscribe({
        next: response => {
          if (response.data) {
            this.course = response.data;

            this.breadcrumbService.setBreadcrumb({
              display_name: this.course.name || this.course.course_name || 'Convocatoria',
              url: `/dashboard/convocatorias/${courseId}`,
              items: [
                { name: 'Convocatoria de Cursos', url: '/dashboard/convocatorias' },
                { name: this.course.name || this.course.course_name || 'Convocatoria', url: `/dashboard/convocatorias/${courseId}` }
              ]
            });

            this.mapTeacherIdsFromUsers();

            // Construir studentFormFields con el course_call_id
            this.studentFormFields = [
              { 
                name: 'user_ids', 
                type: 'select', 
                label: 'Alumno', 
                colspan: 2, 
                singleSelection: false, 
                validations: 'required', 
                url: `/user/students?course_call_id=${this.course.id}` 
              },
            ];

            // Construir lessonUsersFormField con el course_call_id
            this.lessonUsersFormField = [
              { 
                name: 'listeners', 
                type: 'select', 
                label: 'Oyentes', 
                colspan: 2, 
                singleSelection: false, 
                url: `/user/students?course_call_id=${this.course.id}` 
              }
            ];

            this.courseForm = {
              method: 'PUT',
              successTitle: 'Edición correcta',
              errorTitle: 'Error en la edición',
              fields: this.courseFormFields,
              name: 'tipo de curso',
              createButtonTitle: '',
              cols: 2,
              createApiSlug: '',
              updateApiSlug: '/course/update/' + this.course.id,
              formTitle: this.course.name ? 'Editar' + this.course.name : 'Editar ' + this.course.course_name,
              formButtonTitle: 'Editar',
              finishLabel: 'Guardar Cambios',
              width: '4xl',
              steps: [
                { label: 'Curso y fechas', fieldNames: ['course_id', 'start_date', 'end_date', 'registration_deadline', 'expiration_date', 'capacity'] },
                { label: 'Ubicacion y profesores', fieldNames: ['office_id', 'classroom_id', 'teachers'] },
                { label: 'Clases', fieldNames: ['lessons'] },
              ]
            }

            this.studentForm = {
              successTitle: 'Alumno asignado correctamente',
              errorTitle: 'Error al asignar alumno',
              method: 'POST',
              fields: this.studentFormFields,
              name: 'asignación',
              createButtonTitle: 'Nuevo Alumno',
              cols: 2,
              createApiSlug: '/course/add-user/' + this.course.id,
              formTitle: 'Asignar Alumno',
              formButtonTitle: 'Guardar',
              width: '2xl'
            };

            // Crear GenericCRUD para estudiantes
            this.studentsCRUD = {
              genericForm: this.studentForm,
              genericTable: {
                columns: [],
                items: [],
                type: 'generic',
                loadItemsSlug: '',
                paginate: false,
                name: 'estudiantes',
                actions: [],
                details: false
              },
              useModalForm: true
            };

            // UX: si hay una clase hoy, seleccionarla al entrar.
            this.autoSelectTodayLesson();
            this.selectedLesson = this.course.lessons[this.lessonIndexTab]

            // Inicializar chat privado
            this.initializePrivateChatCrud();

            this.buildStudentCruds();

            // Cargar calificaciones para la evaluación inline
            if (this.qualifications.length === 0) {
              this.genericCrudService.list('/config/qualification/list').subscribe({
                next: (res: any) => {
                  this.qualifications = res.data || res || [];
                }
              });
            }

          }
        },
        error(err) {
          console.log(err);
        },
      });
    }
  }

  /** UX: selecciona la clase de hoy en "Horarios y asistencias" si existe. */
  private autoSelectTodayLesson(): void {
    const lessons = this.course?.lessons ?? [];
    const t = this.today;
    const todayStr = `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, '0')}-${String(t.getDate()).padStart(2, '0')}`;
    const idx = lessons.findIndex((l: any) => (l?.date ?? '').slice(0, 10) === todayStr);
    if (idx >= 0) {
      this.lessonIndexTab = idx;
    }
  }

  private buildStudentCruds() {
    this.studentCruds = this.course.lessons.map(lesson => {
      const items = lesson.users
        .filter((item: any) => !item.pivot.teacher)
        .map((item: any) => ({
          ...item,
          lesson_user_id: item.pivot.id,
          user_id: item.pivot.user_id,
          lesson_id: item.pivot.lesson_id,
          presence: item.pivot.presence,
          observations: item.pivot.observations,
          listener: item.pivot.listener
        }));
      const table: GenericTable<any> = {
        columns: this.lessonUsersTableCols,
        items: items,
        type: 'lesson',
        loadItemsSlug: '/course/students/' + this.course.id + '/' + lesson.id,
        paginate: true,
        name: 'alumnos',
        details: false,
        actions: [
          {
            name: 'Eliminar oyente',
            key: 'delete',
            method: 'DELETE',
            icon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>',
            confirmation: true,
            questionText: '¿Desea eliminar este oyente?',
            deleteRowOnResponse: true,
            actionSlug: '/course/lesson-user/{{lesson_user_id}}',
            showIf: (item) => item.listener
          },
        ],
        bulkActions: [
          {
            name: 'Marcar asistencia',
            key: 'mark-presence',
            method: 'POST',
            confirmation: false,
            icon: '<svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="w-4"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M9 11l3 3l8 -8" /><path d="M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9" /></svg>',
            actionSlug: '/course/bulk-change-presence'
          },
          {
            name: 'Asignar calificación',
            key: 'mark-qualification',
            method: 'POST',
            confirmation: false,
            icon: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0 1 18 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3 1.5 1.5 3-3.75" /></svg>',
            actionSlug: `/course/${this.course.id}/bulk-change-qualification`,
            form: {
              method: 'POST',
              successTitle: 'Calificación asignada correctamente',
              errorTitle: 'Error al asignar calificación',
              fields: [
                {
                  name: 'qualification_id',
                  type: 'select',
                  label: 'Calificación',
                  validations: 'required',
                  url: '/config/qualification/list',
                  singleSelection: true,
                  colspan: 2
                }
              ],
              name: 'calificación',
              createButtonTitle: '',
              cols: 2,
              createApiSlug: `/course/${this.course.id}/bulk-change-qualification`,
              formTitle: 'Asignar calificación a alumnos',
              formButtonTitle: 'Asignar',
              width: '2xl'
            }
          },
        ]
      };

      const form: GenericForm = {
        successTitle: 'Oyentes añadidos',
        errorTitle: 'Error al añadir oyentes',
        method: 'POST',
        fields: this.lessonUsersFormField,
        name: 'curso',
        createButtonTitle: 'Añadir oyentes',
        cols: 2,
        createApiSlug: '/course/add-listeners/' + lesson.id,
        formTitle: 'Añadir oyentes',
        formButtonTitle: 'Añadir oyentes',
        width: '4xl',
      }

      const crud: GenericCRUD<any> = {
        genericTable: table,
        genericForm: form,
        useModalForm: true
      };

      return crud;
    });
  }

  // --- Evaluación masiva de alumnos ---

  toggleStudentSelection(studentId: number) {
    const newSet = new Set(this.selectedStudentIds);
    if (newSet.has(studentId)) {
      newSet.delete(studentId);
    } else {
      newSet.add(studentId);
    }
    this.selectedStudentIds = newSet;
  }

  toggleAllStudents() {
    if (this.areAllStudentsSelected()) {
      this.selectedStudentIds = new Set();
    } else {
      this.selectedStudentIds = new Set(this.course.students?.map((s: any) => s.id) || []);
    }
  }

  areAllStudentsSelected(): boolean {
    return this.course?.students?.length > 0 && this.selectedStudentIds.size === this.course.students.length;
  }

  clearStudentSelection() {
    this.selectedStudentIds = new Set();
  }

  assignQualification() {
    if (!this.selectedQualificationId) {
      this.toastr.warning('Selecciona una calificación');
      return;
    }
    if (this.selectedStudentIds.size === 0) {
      this.toastr.warning('Selecciona al menos un alumno');
      return;
    }
    this.assigningQualification = true;
    const payload = {
      user_ids: Array.from(this.selectedStudentIds),
      qualification_id: this.selectedQualificationId
    };
    this.genericCrudService.reqByMethod(
      `/course/${this.course.id}/bulk-change-qualification`, 'POST', payload
    ).subscribe({
      next: () => {
        this.toastr.success('Calificación asignada correctamente');
        this.selectedStudentIds = new Set();
        this.selectedQualificationId = null;
        this.assigningQualification = false;
        // Recargar curso
        this.courseService.get(this.course.id).subscribe({
          next: response => {
            if (response.data) {
              this.course = response.data;
              this.buildStudentCruds();
            }
          }
        });
      },
      error: () => {
        this.toastr.error('Error al asignar calificación');
        this.assigningQualification = false;
      }
    });
  }

  /** trackBy estable: el getter devuelve un array nuevo cada CD; sin esto los
   *  nodos de las tabs se recrean en cada ciclo (con el toast, CD constante) y
   *  el click no cuaja porque el nodo desaparece entre mousedown y mouseup. */
  trackByTabLabel = (_: number, tab: any) => tab.label;

  get detailsTabs() {
    const tabs = [
      { label: 'Información del curso' },
    ];

    if (this.course?.course?.virtual_classroom?.units?.length > 0) {
      tabs.push({ label: 'Aula Virtual' });
    }

    // Solo mostrar tab de horarios para cursos NO prácticos
    if (this.course?.course?.type !== 'Practico') {
      tabs.push({ label: 'Horarios y asistencias' });
    }

    tabs.push({ label: 'Chat' });

    return tabs;
  }

  get currentTabLabel(): string {
    return this.detailsTabs[this.activeTabIndex]?.label;
  }

  private mapTeacherIdsFromUsers() {
    this.course.lessons = this.course.lessons.map((lesson: any) => {
      const teacherIds = lesson.users
        ?.filter((u: any) => u.pivot?.teacher)
        .map((u: any) => u.id) ?? [];

      return {
        ...lesson,
        teacher_ids: teacherIds
      };
    });
  }

  parseDateFromString(dateStr: string): Date {
    const parsedDate = new Date(dateStr);

    // Verifica si la fecha es válida
    return parsedDate;
  }

  toggleActiveCourseForm() {
    this.activeCourseForm = !this.activeCourseForm;
  }

  ngAfterViewInit() {
    // Interceptar el botón del CRUD después de que se renderice
    setTimeout(() => {
      const button = this.studentsCrud?.nativeElement?.querySelector('button');
      if (button) {
        button.addEventListener('click', (event: Event) => {
          if (!this.allowOpenModal) {
            event.preventDefault();
            event.stopPropagation();
            this.checkStudentsAndOpenForm();
          }
        }, { capture: true });
      }
    }, 100);
  }

  checkStudentsAndOpenForm() {
    this.courseService.checkAvailableStudents(this.course.id).subscribe({
      next: (response: any) => {
        if (response.success && response.data && response.data.length === 0) {
          this.toastr.warning(
            'No hay alumnos disponibles para asignar. Todos los alumnos con el producto correspondiente ya están inscritos en este curso.',
            'Sin alumnos disponibles',
            { timeOut: 5000 }
          );
        } else {
          // Permitir abrir el modal
          this.allowOpenModal = true;
          const button = this.studentsCrud?.nativeElement?.querySelector('button');
          if (button) {
            button.click();
          }
          // Resetear la bandera después
          setTimeout(() => this.allowOpenModal = false, 100);
        }
      },
      error: () => {
        // Si hay error, abrir de todas formas
        this.allowOpenModal = true;
        const button = this.studentsCrud?.nativeElement?.querySelector('button');
        if (button) {
          button.click();
        }
        setTimeout(() => this.allowOpenModal = false, 100);
      }
    });
  }

  toggleActiveUnitForm(id: number | null = null) {
    this.activeUnitForm = !this.activeUnitForm;
    if (this.activeUnitForm && id) {
      this.selectedUnit = this.course.course.virtual_classroom.units.find(unit => unit.id === id) as Unit;
      this.unitForm = {
        successTitle: 'Edición correcta',
        errorTitle: 'Error en la edición',
        method: 'PUT',
        fields: this.unitFormFields,
        name: 'unit',
        createButtonTitle: '',
        cols: 2,
        createApiSlug: '',
        originalUpdateApiSlug: '',
        updateApiSlug: '/config/unit/update/' + this.selectedUnit?.id,
        uploadFilesUrl: '/config/unit/update-files/' + this.selectedUnit?.id,
        originalUploadFilesUrl: '',
        formTitle: '',
        formButtonTitle: 'Editar',
        updateFormTitle: 'Editar Unidad',
        updateFormButtonTitle: 'Editar Unidad',
        width: '4xl'
      }
    } else {
      this.selectedUnit = undefined;
    }
  }

  reloadStudentCruds() {
    this.genericCruds.forEach(c => c.genericTable.listItems());
  }

  onFinishCourseForm() {
    this.toggleActiveCourseForm();
    if (this.course) {
      this.courseService.get(this.course.id).subscribe({
        next: response => {
          if (response.data) {
            this.course = response.data;
            this.mapTeacherIdsFromUsers();
            this.buildStudentCruds();

          }
        }
      })
    }
  }

  onFinishUnitForm() {
    if (this.selectedUnit) {
      this.toggleActiveUnitForm(this.selectedUnit.id);
      if (this.course) {
        this.courseService.get(this.course.id).subscribe({
          next: response => {
            if (response.data) {
              this.course = response.data;
              this.mapTeacherIdsFromUsers();
            }
          }
        })
      }
    }
  }

  onFinishStudentForm() {
    this.activeStudentForm = false;
    if (this.course) {
      this.courseService.get(this.course.id).subscribe({
        next: response => {
          if (response.data) {
            this.course = response.data;
            this.buildStudentCruds();

          }
        },
        error: () => {
          this.toastr.error('Error al recargar el curso');
        }
      })
    }
  }

  openBookModal(medias: Media[] | undefined) {
    if (medias) {
      this.medias = medias;
      this.showBookModal = true;
    }
  }

  closeBookModal() {
    this.showBookModal = false;
    this.medias = null;
  }

  openVideoModal(medias: Media[] | undefined) {
    if (medias) {
      this.medias = medias;
      this.showVideoModal = true;
    }
  }

  closeVideoModal() {
    this.showVideoModal = false;
    this.medias = null;
  }

  openImageModal(medias: Media[] | undefined) {
    if (medias) {
      this.medias = medias;
      this.showImageModal = true;
    }
  }

  closeImageModal() {
    this.showImageModal = false;
    this.medias = null;
  }


  openChatModal(unitId: number) {
    this.showChatModal = true;
    this.selectedUnit = this.course.course.virtual_classroom.units.find(unit => unit.id === unitId) as Unit;
    this.courseQuestions = this.course.questions.filter(courseQuestion => courseQuestion.unit_id === unitId);
  }

  closeChatModal() {
    this.showChatModal = false;
    this.selectedUnit = undefined;
  }

  // Chat privado - Redirigir a la sección de mensajes
  openPrivateChat(studentId: number, studentName: string) {
    // Crear o buscar el chat privado con el alumno
    this.courseService.createPrivateChat(studentId, this.userId, this.course.id).subscribe({
      next: (chatResponse) => {
        // Obtener el ID del chat
        let chatId = null;
        if (chatResponse.success && chatResponse.data && chatResponse.data.id) {
          chatId = chatResponse.data.id;
        } else if (chatResponse.id) {
          chatId = chatResponse.id;
        } else if (chatResponse.data && chatResponse.data.id) {
          chatId = chatResponse.data.id;
        }

        // Redirigir a la sección de mensajes con el chat abierto
        if (chatId) {
          this.router.navigate(['/dashboard/mensajes'], { 
            queryParams: { chatId: chatId }
          });
        } else {
          // Si no se pudo obtener el ID, redirigir solo a mensajes
          this.router.navigate(['/dashboard/mensajes']);
          this.toastr.info('Abriendo sección de mensajes...', 'Chat');
        }
      },
      error: (error) => {
        console.error('Error creando/obteniendo chat privado:', error);
        this.toastr.error('No se pudo abrir el chat', 'Error');
      }
    });
  }

  closePrivateChatModal() {
    this.showPrivateChatModal = false;
    this.selectedTeacher = null;
    this.privateChatMessages = [];
    this.newPrivateMessageText = '';
    this.currentChatId = null;
  }

  loadPrivateChatMessages(teacherId: number) {
    // Primero necesitamos obtener o crear el chat privado
    this.courseService.createPrivateChat(this.userId, teacherId, this.course.id).subscribe({
      next: (chatResponse) => {
        // Manejar diferentes estructuras de respuesta
        let chatId = null;
        if (chatResponse.success && chatResponse.data && chatResponse.data.id) {
          chatId = chatResponse.data.id;
        } else if (chatResponse.id) {
          chatId = chatResponse.id;
        } else if (chatResponse.data && chatResponse.data.id) {
          chatId = chatResponse.data.id;
        }

        if (chatId) {
          this.currentChatId = chatId;

          // Ahora cargar los mensajes del chat
          this.courseService.getPrivateMessages(chatId).subscribe({
            next: (messagesResponse) => {
              // Transformar los mensajes para que tengan la estructura correcta
              this.privateChatMessages = (messagesResponse || []).map((message: any) => ({
                id: message.id,
                senderId: message.sender_id || message.senderId || this.userId,
                message: message.message,
                timestamp: message.created_at || message.timestamp,
                sender: message.sender || { name: message.sender_name || 'Usuario' },
                is_read: message.is_read || false
              }));
            },
            error: (error) => {
              console.error('Error cargando mensajes privados:', error);
              this.privateChatMessages = [];
            }
          });
        } else {
          console.error('No se pudo obtener el ID del chat de la respuesta:', chatResponse);
          // Solución temporal: usar un ID falso para probar
          this.currentChatId = 999;
          this.privateChatMessages = [];
        }
      },
      error: (error) => {
        console.error('Error creando/obteniendo chat privado:', error);
        this.privateChatMessages = [];
      }
    });
  }

  initializePrivateChatCrud() {
    this.privateChatCrud = {
      genericTable: {
        columns: this.privateChatTableColumns,
        items: [], // Inicialmente vacío para que haga la petición
        loadItemsSlug: `/api/chat/private/conversations/${this.course.id}`,
        type: 'generic',
        paginate: false,
        name: 'chat-privado',
        actions: this.privateChatTableActions
      }
    };

    // Hacer la petición manualmente y manejar la respuesta
    this.courseService.getPrivateConversations(this.course.id).subscribe({
      next: (response) => {
        // La API devuelve directamente un array de chats
        if (response && Array.isArray(response)) {
          this.privateChatCrud.genericTable!.items = response;
        } else {
          // Si la API no devuelve datos, mostrar lista vacía
          this.privateChatCrud.genericTable!.items = [];
        }
      },
      error: (error) => {
        // En caso de error, mostrar lista vacía
        this.privateChatCrud.genericTable!.items = [];
      }
    });
  }

  sendPrivateMessage() {
    if (this.newPrivateMessageText.trim() && this.selectedTeacher && this.currentChatId) {
      const messageText = this.newPrivateMessageText;

      this.courseService.sendPrivateMessage(this.currentChatId, messageText).subscribe({
        next: (response) => {
          if (response) {
            // Agregar el mensaje a la lista local
            const newMessage = {
              id: response.id || Date.now(),
              senderId: this.userId,
              message: messageText,
              timestamp: new Date().toISOString(),
              sender: { name: 'Tú' },
              is_read: false
            };

            this.privateChatMessages.push(newMessage);
            this.newPrivateMessageText = '';

            // Actualizar la conversación en la tabla
            this.updateConversationInTable(this.selectedTeacher.id, messageText);
          }
        },
        error: (error) => {
          console.error('Error enviando mensaje privado:', error);
          // En caso de error, agregar el mensaje localmente
          const newMessage = {
            id: Date.now(),
            senderId: this.userId,
            message: messageText,
            timestamp: new Date().toISOString(),
            sender: { name: 'Tú' },
            is_read: false
          };

          this.privateChatMessages.push(newMessage);
          this.newPrivateMessageText = '';

          // Actualizar la conversación en la tabla
          this.updateConversationInTable(this.selectedTeacher.id, messageText);
        }
      });
    }
  }

  onPrivateChatAction(action: any) {
    if (action.key === 'open-chat') {
      this.openPrivateChat(action.item.teacher_id, action.item.teacher_name);
    } else if (action.key === 'mark-read') {
      this.markConversationAsRead(action.item.id);
    }
  }

  markConversationAsRead(conversationId: number) {
    // Aquí marcarías la conversación como leída
    console.log('Marcando conversación como leída:', conversationId);
  }

  updateConversationInTable(teacherId: number, lastMessage: string) {
    // Actualizar la conversación en la tabla del GenericCRUD
    if (this.privateChatCrud.genericTable?.items) {
      const conversation = this.privateChatCrud.genericTable.items.find((conv: any) => conv.teacher_id === teacherId);
      if (conversation) {
        conversation.last_message = lastMessage;
        conversation.last_message_date = new Date().toISOString();
        conversation.status = 'Mensaje enviado';
        conversation.unread_count = 0;
      }
    }
  }

  // Método para manejar las acciones del chat privado después de la ejecución
  handlePrivateChatActionAfterExecution(action: any) {
    if (action.key === 'open-chat') {
      const teacherId = action.item.teacher_id;
      const teacherName = action.item.teacher_name;
      this.openPrivateChat(teacherId, teacherName);
    } else if (action.key === 'mark-read') {
      const conversationId = action.item.id;
      this.markConversationAsRead(conversationId);
    }
  }

  // Método para abrir chat privado de forma segura
  openPrivateChatSafely() {
    if (this.course?.teachers && this.course.teachers.length > 0) {
      const teacher = this.course.teachers[0];
      this.openPrivateChat(teacher.id, teacher.name);
    }
  }

  newCommentText: string = '';

  newQuestionText: string = '';

  repliesVisible: Set<number> = new Set();

  toggleReplies(chatId: number) {
    if (this.repliesVisible.has(chatId)) {
      this.repliesVisible.delete(chatId);
    } else {
      this.repliesVisible.add(chatId);
    }
  }

  sendComment(unitId: number | null) {


    const comment = this.newCommentText.trim();
    if (!comment) return;

    let data: any = {
      course_id: this.course.id,
      unit_id: unitId,
      user_id: this.userId,
      comment: comment,
    }

    this.courseService.createCourseChat(data).subscribe({
      next: (response) => {
        if (response.success) {

          if (this.courseChats) {
            this.courseChats.unshift(response.data);
          } else {
            this.course.course_chats.unshift(response.data)
          }
        }
        this.newCommentText = '';
      },
      error: (err) => console.error('Error enviando comentario', err)
    });
  }

  sendQuestion(unitId: number | null) {
    const question = this.newQuestionText.trim();
    if (!question) return;

    let data: any = {
      course_id: this.course.id,
      unit_id: unitId,
      content: question,
      parent_id: null
    }

    this.courseService.createQuestion(data).subscribe({
      next: (response) => {
        if (response.success) {
          if (response.success) {
            const newQuestion = {
              ...response.data,
              answers: []
            };

            if (this.courseQuestions) {
              this.courseQuestions.unshift(newQuestion);
            } else {
              this.course.questions.unshift(newQuestion);
            }

            this.newQuestionText = '';
          }
          this.loadCourse();
        }
        this.newQuestionText = '';
      },
      error: (err) => console.error('Error enviando pregunta', err)
    });
  }

  isRepliesVisible(chatId: number): boolean {
    return this.repliesVisible.has(chatId);
  }

  activeReplyInput: number | null = null;
  replyText: { [key: number]: string } = {};

  toggleReplyInput(chatId: number) {
    this.activeReplyInput = this.activeReplyInput === chatId ? null : chatId;
  }

  activeAnswerInput: number | null = null;
  answerText: { [key: number]: string } = {};

  toggleAnswerInput(questionId: number) {
    this.activeAnswerInput = this.activeAnswerInput === questionId ? null : questionId;
  }

  sendReply(chatId: number, unitId: number | null) {
    const comment = this.replyText[chatId]?.trim();
    if (!comment) return;

    let data: any = {
      course_id: this.course.id,
      unit_id: unitId,
      user_id: this.userId,
      comment: comment,
      course_chat_id: chatId,
    }

    this.courseService.createCourseChat(data).subscribe({
      next: (response) => {
        if (response.success) {

          if (this.courseChats) {
            const chatUnit = this.courseChats.find(c => c.id === chatId);
            if (chatUnit) chatUnit.replies.unshift(response.data);
          } else {
            const chat = this.course.course_chats.find(c => c.id === chatId);
            if (chat) chat.replies.unshift(response.data);
          }
          this.replyText[chatId] = '';
          this.activeReplyInput = null;
        }
      },
      error: (err) => console.error('Error enviando respuesta', err)
    });
  }

  sendAnswer(questionId: number, unitId: number | null) {
    const answer = this.answerText[questionId]?.trim();

    if (!answer) return;

    let data: any = {
      course_id: this.course.id,
      unit_id: unitId,
      content: answer,
      parent_id: questionId,
    }

    this.courseService.createQuestion(data).subscribe({
      next: (response) => {
        if (response.success) {
          if (this.courseQuestions) {
            const question = this.courseQuestions.find(q => q.id === questionId);
            if (question) question.answers.unshift(response.data);
          } else {
            const question = this.course.questions.find(q => q.id === questionId);
            if (question) question.answers.unshift(response.data);
          }
          this.answerText[questionId] = '';
          this.activeAnswerInput = null;
          this.loadCourse();
        }
      },
      error: (err) => console.error('Error enviando respuesta', err)
    })
  }

  deleteCourseQuestion(questionId: number) {
    this.courseService.deleteQuestion(questionId).subscribe({
      next: (response) => {
        if (response.success) {
          const isAnswer = this.courseQuestions?.some(q => q.answers?.some(a => a.id === questionId));
          if (isAnswer) {
            this.courseQuestions?.forEach(q => {
              q.answers = q.answers?.filter(a => a.id !== questionId);
            });
          } else {
            if (this.courseQuestions !== null) {
              this.courseQuestions = this.courseQuestions?.filter(q => q.id !== questionId);
            }
          }
          this.loadCourse();
        }
      },
      error: (err) => console.error('Error eliminando pregunta', err)
    })

  }

  getTimeAgo(dateString: string): string {
    const pastDate = new Date(dateString);
    const diffMs = this.today.getTime() - pastDate.getTime();

    const seconds = Math.floor(diffMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30);
    const years = Math.floor(days / 365);

    if (years > 0) return `hace ${years} año${years > 1 ? 's' : ''}`;
    if (months > 0) return `hace ${months} mes${months > 1 ? 'es' : ''}`;
    if (days > 0) return `hace ${days} día${days > 1 ? 's' : ''}`;
    if (hours > 0) return `hace ${hours} hora${hours > 1 ? 's' : ''}`;
    if (minutes > 0) return `hace ${minutes} minuto${minutes > 1 ? 's' : ''}`;
    return `hace unos segundos`;
  }

  downloadFile(media: Media) {
    window.open(media.original_url, '_blank');
  }


  getLessonDateTime(lesson: any): Date {
    return new Date(`${lesson.date}T${lesson.start_time}`);
  }

  getTeachersFromLesson(lesson: Lesson): string[] {
    if (!lesson || !lesson.users) return [];
    return lesson.users
      .filter(u => u.pivot?.teacher)
      .map(u => u.name);
  }

}
